module.exports = __webpack_public_path__ + "static/media/account_off.90c204ee.svg";